import React, { useRef, useState } from "react";
import ndovuHr from "../../../assets/img/ndovuPayShield.png";
import ReactPasswordChecklist from "react-password-checklist";
import svg103 from "../../../assets/svg/svg103.svg";
import toast from "react-hot-toast";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import svgone from "../../../assets/svg/svgone.svg";
import svg85 from "../../../assets/svg/svg85.svg";
import { save } from "../../../features/auth/authSlice";

function RegisterSeeker() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { authLoading, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const onFinish = async (data) => {
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[A-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(password) &&
      password === confirmPassword;
    if (!isPasswordValid) {
      toast.error(
        "Password does not meet the required conditions or does not match"
      );
      return;
    }

    const res = await dispatch(
      save({
        ...data,
        url: "auth/register",
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
      await navigate("/recruitment/login-seeker");
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  return (
    <div className=" h-screen  w-full overflow-y-scroll">
      <div className="flex items-center justify-center text-center h-full">
        <div
          className="lg:w-[43.75rem] w-full border border-[rgba(243,183,64,0.5)] cardSeeker rounded-[1.25rem] bg-white
    lg:px-[5rem] px-3 py-[2.5rem]"
        >
          <div className="flex lg:gap-[2rem] gap-[1rem]">
            <img
              loading="lazy"
              decoding="async"
              src={ndovuHr}
              alt="logo"
              className="w-[5.5rem]  h-[5rem] object-contain"
            />
            <div className="flex flex-col items-start">
              <span className="text-[#050505] text-[1.5rem] font-[600] font-dmSans">
                Welcome to Ndovu HR
              </span>
              <span className="text-[#828282] text-[1.125rem] font-[500] font-dmSans">
                Register with us
              </span>
            </div>
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="w-full mt-[2.5rem]"
            form={form}
          >
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-[1.5rem]">
              <Form.Item
                label="First Name"
                name="usrFirstName"
                rules={[
                  {
                    required: true,
                    message: "Please input your first name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                label="Last Name"
                name="usrLastName"
                rules={[
                  {
                    required: true,
                    message: "Please input your last name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
            </div>

            <Form.Item
              name="usrEmail"
              label="Enter Email"
              rules={[
                {
                  required: true,
                  message: "Add email address",
                },
                {
                  type: "email",
                  message: "Enter a valid email",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="usrPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <Form.Item
              label="Confirm password"
              name="usrEncryptedPasswordAlt"
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <div className="mt-[.32rem]">
              <ReactPasswordChecklist
                className="text-darkBlue flex flex-col items-start gap-1 w-full text-sm sm:text-base md:text-lg"
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                messages={{
                  minLength: "A minimum of 8 characters",
                  number: "At least one number (0-9)",
                  capital: "At least one upper case letter (A-Z)",
                  match: "Confirm password to match with the password",
                  specialChar:
                    "At least one special character e.g !@#$%^&*()_+{}[]:;?/|\\",
                }}
                iconComponents={{
                  ValidIcon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-darkBlue"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  ),
                  InvalidIcon: (
                    <img
                      className="pr-1 sm:pr-2 w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
                      src={svgone}
                      alt="lazy"
                    />
                  ),
                }}
                validColor="#147CBC"
                iconSize={20} // px → consistent with Tailwind sizing
              />
            </div>

            <div className="text-[#828282] text-[.875rem] font-[400] flex items-center gap-1 mt-[1rem]">
              Have an account?{" "}
              <span className="text-[#1A1A1A] font-[600] cursor-pointer" onClick={()=>navigate('/recruitment/login-seeker')}>Sign In</span>
            </div>

            <button
              disabled={authLoading}
              className={`cstm-btn mt-[2.5rem]`}
              type="submit"
            >
              {authLoading ? <Spin /> : "Register"}
            </button>

            <button className={`cstm-btn-2 mt-[1rem] gap-[1rem]`} type="button">
              <img src={svg103} alt="svg103" /> Continue with google
            </button>

            <div
              className="mt-[2.5rem] flex items-center text-[#000] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <img src={svg85} alt="svg85" /> Back
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default RegisterSeeker;
